export const VIDEO_QUERY_KEYS = {
  base: ['videos'],
  count: (): string[] => [...VIDEO_QUERY_KEYS.base, 'count'],
  filtered: (filters?: AnyObject): unknown[] => [...VIDEO_QUERY_KEYS.base, 'filtered', filters],
  video: (videoId: number): unknown[] => [...VIDEO_QUERY_KEYS.base, videoId],
};
